// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LHhH9h {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-3);
}

.kjLrtM {
  width: 72px;
  height: 72px;
}

.vTE_K2 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  text-align: center;
  margin-bottom: var(--spacing-1);
  margin-top: var(--spacing-3);
}

.EpVSSc {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/NoAccountsError/NoAccountsError.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;AACpB","sourcesContent":[".container {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-3);\n}\n\n.icon {\n  width: 72px;\n  height: 72px;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  text-align: center;\n  margin-bottom: var(--spacing-1);\n  margin-top: var(--spacing-3);\n}\n\n.message {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LHhH9h`,
	"icon": `kjLrtM`,
	"title": `vTE_K2`,
	"message": `EpVSSc`
};
module.exports = ___CSS_LOADER_EXPORT___;
